<template>
  <div>
    <ProductRequirementsModal
      v-bind="{ product, updating }"
      v-on="{ submit: handleProductUpdate }"
    />
  </div>
</template>

<script>
import ProductRequirementsModal from '@/components/Products/RequirementsModal.vue';
import { productComputed, productMethods } from '@/store/adminHelper';

export default {
  name: 'PackageRequirements',
  components: {
    ProductRequirementsModal,
  },
  data: () => ({
    updating: false,
  }),
  computed: {
    ...productComputed,
  },
  methods: {
    ...productMethods,
    handleProductUpdate(productData) {
      this.updating = true;
      const { id: productId } = this.product;
      this.updateProduct({ productId, productData })
        .then(() => {
          this.updating = false;
          this.redirectToPackage();
        })
        .catch(() => {
          this.updating = false;
        });
    },
    redirectToPackage() {
      this.$router.go(-1);
    },
  },
};
</script>
